import { render, staticRenderFns } from "./NameAndSocialName.vue?vue&type=template&id=2ca94cbc"
import script from "./NameAndSocialName.vue?vue&type=script&lang=js"
export * from "./NameAndSocialName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports